import { render, staticRenderFns } from "./InventoryHistoricalCostReport.vue?vue&type=template&id=2e1afb70&scoped=true"
import script from "./InventoryHistoricalCostReport.vue?vue&type=script&lang=js"
export * from "./InventoryHistoricalCostReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryHistoricalCostReport.vue?vue&type=style&index=0&id=2e1afb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1afb70",
  null
  
)

export default component.exports